namespace SPA
{
	export namespace LRM /* land_region_map */
	{

		export class Page
			extends ui.tab.TabHTMLPresentation
		{

			private	m_Object:	Wollmilch.LandMapRegion.LRMObject;
			private	m_Parent:	JQuery|null;

			public constructor( object: Wollmilch.LandMapRegion.LRMObject )
			{
				super( 'box' );

				this.m_Object	= object;
				this.m_Parent	= null;

				this.Initialize( { } );
			}

			public rebuild( root: ui.base.BaseHTMLElement|JQuery<HTMLElement> ): Page
			{
				this.m_Parent	= root instanceof ui.base.BaseHTMLElement ? root.Root() : root;

				this.empty();

				const obj = this.m_Object.ToObject();

				this.append( ui.$$.p().addClass( 'box-title' ).text( app.getMessage( 'LandRegionMap.Name' ) + ": " + obj.ObjectNumber ) );

				new SPA.Navigation.BreadCrumb( this.m_Object.ToObject().ObjectNumber ).appendTo( this );

				const	right	= ui.$$.div().addClass( 'col-xs-12 col-md-6' ).css( 'padding', '8px 16px' );
				const	left	= ui.$$.div().addClass( 'col-xs-12 col-md-6' ).css( 'padding', '8px 16px' );

				ui.$$.div().addClass( 'container-fluid' ).append( ui.$$.div().addClass( 'row' ).append( left ).append( right ) ).appendTo( this.Root() );

				ui.$$.h( 4, app.getMessage( 'Address.TYPE.LONG.PostalAddress' ) ).appendTo( right );

				SPA.gui.Address.PostalAddressNormalizedWithMap( obj.Object.Address ).appendTo( right );

				const width	= ( this.m_Object.getState() === 'PENDING' ? 20 : ( this.m_Object.getState() === 'TRANSMITTED' ? 40 : ( this.m_Object.getState() === 'PROCESSING' ? 60 : 100 ) ) );
				let cntxt	= 'success';

				if ( width < 80 ) {	cntxt	= 'info'; }
				if ( width < 50 ) {	cntxt	= 'warning'; }
				if ( width < 25 ) {	cntxt	= 'danger'; }

				ui.$$.p().text( app.getMessage( 'LandRegionMap.STATE.' + this.m_Object.getState() ) ).appendTo( left ).addClass( 'text-' + cntxt );

				new ui.base.BaseHTMLElement( 'div' )
				.addClass( 'progress' )
				.append(
					new ui.base.BaseHTMLElement( 'div' )
					.addClass( 'progress-bar progress-bar-' + cntxt + ' progress-bar-striped active' )
					.css(
						{
							width: width + '%'
						}
					)
				)
				.appendTo( left );

				const	tbody			= new ui.base.BaseHTMLElement( 'tbody' ).append(
					new ui.base.BaseHTMLElement( 'tr' )
						.append( new ui.base.BaseHTMLElement( 'th' ).text( app.getMessage( 'LandRegionMap.TITLE.DOWNLOAD-LIST.KeyDate' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).text( app.getMessage( 'LandRegionMap.TITLE.DOWNLOAD-LIST.Identifier' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).text( app.getMessage( 'LandRegionMap.TITLE.DOWNLOAD-LIST.Size' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).css( 'width', '50px' ).append( ui.$$.span().addClass( 'btn btn-info fa fa-upload' ).on( 'click', () => this.openUploadModal() ) ) )
				);

				this.m_Object.getAttachments().forEach(
					(element) => tbody.append(
						new ui.base.BaseHTMLElement( 'tr' )
							.append( new ui.base.BaseHTMLElement( 'td' ).text( element.getKeyDate().pattern( 'd.m.Y' ) ) )
							.append( new ui.base.BaseHTMLElement( 'td' ).text( element.getArtifact().Identifier() ) )
							.append( new ui.base.BaseHTMLElement( 'td' ).text( element.getArtifact().DataLength() + "Bytes" ) )
							.append( new ui.base.BaseHTMLElement( 'td' ).append( ui.$$.span().addClass( 'btn btn-success fa fa-download' ).on( 'click', () => this.loadBlob( element, this.downloadFile) ) ) )
					)
				);

				tbody.append(
					new ui.base.BaseHTMLElement( 'tr' )
						.append( new ui.base.BaseHTMLElement( 'th' ).text( app.getMessage( 'LandRegionMap.TITLE.DOWNLOAD-LIST.KeyDate' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).text( app.getMessage( 'LandRegionMap.TITLE.DOWNLOAD-LIST.Identifier' ) ) )
						.append( new ui.base.BaseHTMLElement( 'th' ).attr( 'colspan', '2' ).text( app.getMessage( 'LandRegionMap.TITLE.DOWNLOAD-LIST.Size' ) ) )
				);

				ui.$$.div().addClass( 'panel panel-default' ).appendTo( left )
				.append( ui.$$.div().addClass( 'panel-heading' ).css( 'font-weight', 'bold' ).text( this.m_Object.getAttachments().length + ' ' + app.getMessage( 'Aux.BASIC.OBJECT.LANDREGIONMAP.attachments' ) ) )
				.append( ui.$$.div().addClass( 'panel-body' ).append( new ui.base.BaseHTMLElement( 'table' ).addClass( 'table table-striped table-hover' ).append( tbody ).Root() ) );

				super.rebuild( this.m_Parent );

				if ( this.m_Entry ) { this.m_Entry.DeactivateReloadSpin(); }

				return this;
			}

			public reload(): void
			{
				if ( this.m_Entry ) { this.m_Entry.ActivateReloadSpin(); }
				new Wollmilch.AJAX(
					{
						url: 'object/show/' + encodeURIComponent( btoa( this.m_Object.ToObject().ObjectNumber.toString() ) ),
						method: 'GET',
						on:
						{
							success: ( text: string ) =>
							{
								let obj;

								try
								{
									obj = Wollmilch.jsonize( text );

									if ( !obj ) { throw new Error(); }
								}
								catch ( e )
								{
									return;
								}

								if ( obj.success && obj.data )
								{
									this.m_Object	= new Wollmilch.LandMapRegion.LRMObject( obj.data );

									this.rebuild( this.m_Parent as JQuery );
								}
							}
						}
					},
					Wollmilch.AJAXCallbase_e.LRM
				).send();
			}

			private openUploadModal(): void
			{
				let modal: ui.dialog.Modal;
				const FileUpload = ui.$$.div();

				// @ts-ignore
				const galleryUploader = new qq.FineUploader(
					{
						element: FileUpload[ 0 ],
						template: 'qq-template-gallery',
						multiple: false,
						validation:
						{
							allowedExtensions: [ 'pdf' ]
						},
						callbacks:
						{
							onComplete: ( id: number, name: string, responseJSON: any, xhr: XMLHttpRequest ) =>
							{
								if ( responseJSON.success )
								{
									modal.Hide();

									this.reload();
								}
							}
						},
						autoUpload: false,
						emptyError: 'Aux.ERROR.file_empty',
						noFilesError: 'Aux.ERROR.no_files',
						request:
						{
							customHeaders:
							{
								'GSDWollmilch-API-Key': 'API-KEY',
								'GSDWollmilch-API-AuthToken': app.getAuthenticationManager().getAuthToken()
							},
							forceMultipart: true,
							method: 'PUT',
							paramsInBody: true,
							endpoint: ( Wollmilch.useHTTPS ? "https" : "http" ) + "://" + Wollmilch.URL + 'lrm/object/attach/' + encodeURIComponent( btoa( this.m_Object.ToObject().ObjectNumber ) )
						},
						cors:
						{
							// all requests are expected to be cross-domain requests
							expected: true,

							// if you want cookies to be sent along with the request
							sendCredentials: true
						}
					}
				);

				modal = new ui.dialog.Modal(
					{
						size: 'lg',
						head:	[ ui.$$.h( 4, app.getMessage( 'Aux.BASIC.OBJECT.LANDREGIONMAP.attachment-add' ) ) ],
						body: [ FileUpload ],
						foot:	[
							ui.$$.button().text( app.getMessage( 'Aux.SAVE_BTN' ) ).addClass( 'btn btn-success' ).on(
								'click', () =>
								{
									try
									{
										galleryUploader.uploadStoredFiles();
									}
									catch ( nofileserror )
									{
										app.addNotify(
											{
												title: [ 'FILE_UPLOAD' ],
												body: [ 'ERROR.NO_FILES_SELECTED_TO_UPLOAD' ],
												context: 'warning',
												timeout: Number(app.getConfigValue("ToastTimeout"))
											}
										);

										return;
									}
								}
							),
							ui.$$.button().text( app.getMessage( 'Aux.ABORT_BTN' ) ).addClass( 'btn btn-danger' ).on(
								'click', () => modal.Hide()
							)
						]
					}
				);
			}

			private downloadFile( data: Wollmilch.ArtifactDownload, fileName: string )
			{
				const srcStr = 'data:' + data.MimeType + ',';
				const element = document.createElement('a');
				element.setAttribute( 'href', srcStr + data.Blob );
				/* TODO sobald in der DB der Dateiname des Artefaktes mitgespeichert wird, diesen verwenden */
				element.setAttribute( 'download', fileName.replace(/\/|(\:)+/g, '_')/* TODO data.Filename*/ );

				element.style.display = 'none';
				document.body.appendChild(element);

				element.click();

				document.body.removeChild(element);
			}

			private loadBlob(
				att: Wollmilch.LandMapRegion.Attachment,
				onsuccess: ( data: Wollmilch.ArtifactDownload, fileName: string ) => void
			)
			{
				new Wollmilch.AJAX(
					{
						url: 'artifact/download/' + att.getArtifact().ID(),
						method: 'GET',
						on:
						{
							success: ( text: string ) =>
							{
								const obj = Wollmilch.jsonize( text );

								if ( !obj || obj.success === false )
								{
									return;
								}

								onsuccess( obj.data, att.getArtifact().Identifier() );
							}
						}
					}
				).send();
			}

		}

	}
}
